// aospino 2021-08-11
// 
// Funciones para mostrar ocupado un elemento
//
// -------------------------------------
// Ejemplo en llamada http
// -------------------------------------
//  // poner ocupado el div
//  busyUi.busyUi(true, _this.m_element);
//
//  http.get(url,params)
//  .then((result) => {
//
//    // quitar el ocupado del elemento-dashboard
//    busyUi.busyUi(false, _this.m_element);
//  })
//  .catch(( jqXHR, textStatus, errorThrown ) => {
//    var msg = http.errText2Show(jqXHR, errorThrown);
//    dlgUi.showDlgOk(_this.m_element,"Error XXXX.\n"+msg);
//  }); // end http.get
// -------------------------------------
// Ejemplo en hacer grafica
// -------------------------------------
//  // poner ocupado el div
//  busyUi.busyUi(true, _this.m_element);
//  var l_chart = func2MakeChartParams(); // se crean las opciones de la grafica
//  _this.m_chart = new Highcharts.Chart(l_chart, function(){
//    // chart is ready
//    // quitar el ocupado del elemento-dashboard - al finalizar de graficar
//    busyUi.busyUi(false, _this.m_element);
//  });
// -------------------------------------

var $ = require('jquery');
var Device = require("devextreme/core/devices");

var busyUi =  {
  // funcion para poner un ocupado sobre un elemento
  // l_b: bandera de ocupado true/false
  // l_divId: id del elemento que se quiere poner ocupado sin # eje: "div-table-xxxx"
  busyIdUi:(l_b,l_divId)=>{
    // referncia al div
    var l_div = $("#"+l_divId);

    // llamar a la funcion que ocupa el $(div)
    busyUi.busyUi(l_b,l_div);
  },
  // funcion para poner ocupado un elemento
  // l_b: bandera de ocupado true/false
  // l_div: div de jquery para ocupar eje: $("div-table-xxxx")
  busyUi:(l_b,l_div)=>{
    if (l_div==null) return;
    if (l_div.length<=0) return;

    if (l_b) {
      var l_curBusy = l_div.find('.div-busy');
      if (l_curBusy.length>0) {
        // console.log("Ya hay un div busy",l_curBusy);
      } else {
        // creo el div que va sobre y que muestra ocupado
        var l_busy = $("<div class='div-busy' style='float:left;background: rgba(0,0,0,0.5);width:100%;height:100%;' >");
        l_busy.css({position: "absolute", top: 0, left: 0, });
        l_div.append(l_busy);
      }
    } else {
      // remover cualquier ocupado del div
      l_div.find('.div-busy').remove();
    }
  },
  // funcion para verificar si una extensión en el dashboard es visible
  // componentName: nombre del componente a verifica
  // dashboardControl: dashboard
  isExtensionVisible:(componentName,dashboardControl)=>{
    if(Device.default._realDevice.deviceType!="desktop") return true;
    if(componentName.startsWith("popup")) return true;
    let res = false;
    var dashboard = dashboardControl.dashboard();
    if (dashboard==null) return false;   
    var items = dashboard.items();
    if (items==null) return false;        // verificacion de objeto
    var selectedPage = [];
    for(let i=0; i<items.length;i++){
      if(items[i]!=undefined){
        if(items[i].itemType()=="TabContainer") selectedPage.push(items[i]._activeTabPage().componentName());
        if(items[i].componentName()==componentName){
          if(dashboardControl.maximizedDashboardItemName.trim()=="" || (dashboardControl.maximizedDashboardItemName.trim()!="" && items[i].componentName()==dashboardControl.maximizedDashboardItemName))
          {
            if(items[i].parentContainer()==undefined){
            res = true;
            }
            else {
            if(items[i].parentContainer().startsWith('dashboardTabPage')){
                for (let j=0; j<selectedPage.length; j++){
                    if(items[i].parentContainer()==selectedPage[j]){
                       res = true;
                    }
                }
            }
            else if(items[i].parentContainer().startsWith('groupDashboardItem')){
                var groups = dashboard.groups();
                if(groups!=null){
                for(let j=0; j<groups.length; j++){
                    if(items[i].parentContainer()==groups[j].componentName()){
                        let sp = false;
                        for (let k=0; k<selectedPage.length; k++){
                            if(groups[j].parentContainer()==selectedPage[k]){
                               sp = true;
                            }
                        }
                        if(sp || groups[j].parentContainer()==undefined){
                            res = true;
                        }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return res;
  },
}
export default busyUi;